import { FileType, SortBy } from '../types';

/**
 * Client-side file sorting utility for optimistic UI updates
 * Sorts files in memory without requiring server round-trip
 */
export const sortFilesLocally = (
  files: FileType[],
  sortBy: SortBy,
  sortOrder: 'asc' | 'desc',
): FileType[] => {
  // Create a copy to avoid mutating original array
  const filesCopy = [...files];

  filesCopy.sort((a, b) => {
    let comparison = 0;

    switch (sortBy) {
      case 'name': {
        // Case-insensitive alphabetical sort
        comparison = a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        break;
      }

      case 'createdAt': {
        // Sort by timestamp
        const dateA = new Date(a.createdAt).getTime();
        const dateB = new Date(b.createdAt).getTime();
        comparison = dateA - dateB;
        break;
      }

      case 'duration': {
        // Sort by duration, treating undefined as 0
        const durationA = a.duration || 0;
        const durationB = b.duration || 0;
        comparison = durationA - durationB;
        break;
      }

      default: {
        // Fallback to createdAt if unknown sort field
        const defaultDateA = new Date(a.createdAt).getTime();
        const defaultDateB = new Date(b.createdAt).getTime();
        comparison = defaultDateA - defaultDateB;
      }
    }

    // Apply sort order (reverse for descending)
    return sortOrder === 'asc' ? comparison : -comparison;
  });

  return filesCopy;
};
